import { Component, OnInit ,Input , ViewChild , ElementRef} from '@angular/core';
import { GfichierService } from '../../service/gfichier.service';


@Component({
  selector: 'app-printcode',
  templateUrl: './printcode.component.html',
  styleUrls: ['./printcode.component.scss'],
})
export class PrintcodeComponent implements OnInit {

  @Input() code : string;
  @Input() id : number;
  @Input() posi : number;

  @ViewChild('idcode', {static: true}) idcode : ElementRef;
  @ViewChild('idoutput', {static: true}) idoutput : ElementRef;
  @ViewChild('idcanvas', {static: true}) idcanvas : ElementRef;
 

  //code2 : string="code";
  //output : string = "output";
  //canvas : string = "canvas";

  constructor( public gfichier : GfichierService) { }

  ngOnInit() {}

  ngOnChanges() { 

    let str : string ;//= this.code;
  
  if(this.gfichier.getValue(this.posi,this.id,"code2")) {
    str =  this.gfichier.getValue(this.posi,this.id,"code2");
  }  else {
    str = this.code;
  } 
  
  str = str.replace(/\n/g,"<br/>");
  str = str.replace(/ /g,"&nbsp;");
  
  this.idcode.nativeElement.innerHTML = str;
  
  this.idoutput.nativeElement.innerHTML = this.gfichier.getValue(this.posi,this.id,"output");
  
  if(this.gfichier.getValue(this.posi,this.id,"visicanvas")) 
     this.idcanvas.nativeElement.innerHTML = '<img src="'+this.gfichier.getValue(this.posi,this.id,"canvas")+'">';
   

  }

}
